export const AGGREGATE_OPERATION_TYPE = [
  { label: "COUNT_TO", value: "COUNT_TO" },
  { label: "COUNT_DISTINCT", value: "COUNT_DISTINCT" },
  { label: "SUM_TO", value: "SUM_TO" },
  { label: "DEFAULT", value: "DEFAULT" },
  { label: "FIRST_VALUE", value: "FIRST_VALUE" },
  { label: "FIRST_VALUE_WITH_SORT", value: "FIRST_VALUE_WITH_SORT" },
  { label: "STRING_AGG", value: "STRING_AGG" },
  { label: "JSON_AGG", value: "JSON_AGG" },
  { label: "MAX", value: "MAX" },
  { label: "MIN", value: "MIN" },
  { label: "JSON_AGG_NOT_NULL", value: "JSON_AGG_NOT_NULL" },
  { label: "JSON_AGG_NOT_NULL_DISTINCT", value: "JSON_AGG_NOT_NULL_DISTINCT" },
  { label: "DIFFERENCE", value: "DIFFERENCE" },
  { label: "PRODUCT", value: "PRODUCT" },
  { label: "DIVIDE", value: "DIVIDE" },
  { label: "FUNCTION_TO", value: "FUNCTION_TO" },
  { label: "WITH_IF_CASE", value: "WITH_IF_CASE" },
  { label: "CONCATENATION", value: "CONCATENATION" },

];
